<template>
  <div>
    <my-header></my-header>
    <div class="service-container">
      <div class="service-tab">
        <div class="tab-item" v-for="(item,index) of list" :key="index" @click="activeIndex=index">
          <img
            v-if="index == activeIndex"
            :src="'../../../static/home2.0/service' + (index+1) + '-on.png'"
            alt
          />
          <img v-else :src="'../../../static/home2.0/service' + (index+1) + '.png'" alt />
          <span>{{item}}</span>
        </div>
      </div>
      <img src="../../../static/home2.0/empty.png" alt style="margin-top:40px" />
    </div>
    <my-footer v-if="!isJx"></my-footer>
  </div>
</template>

<script>
import myHeader from "../../components/header.vue";
import myFooter from "../../components/footer.vue";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      isJx: false,
      activeIndex: 0,
      list: [
        "安管人员",
        "特种作业人员",
        "建筑八大员",
        "水利三类",
        "二级建造师",
        "职业技能"
      ]
    };
  }
};
</script>

<style lang="less">
.service-container {
  width: 1200px;
  margin: 100px auto 0;
  .service-tab {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    .tab-item {
      position: relative;
      height: 86px;
      span {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 70px;
        padding-left: 55px;
        box-sizing: border-box;
        font-weight: bold;
        color: #fff;
        font-size: 20px;
        line-height: 70px;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/service/index.vue